import { render, staticRenderFns } from "./CityDistrictGender.vue?vue&type=template&id=0cc3d8dc&"
import script from "./CityDistrictGender.vue?vue&type=script&lang=js&"
export * from "./CityDistrictGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports